import { humanizeNumber } from '../../common';

export function assembleFloorPlanCoreNavBtnsData( floorPlanData ) {
  const navBtns = [];

  if ( !floorPlanData ) {
    return navBtns;
  }

  const {
    description,
    finishCollection,
    furnitureConfiguratorUrl,
    photoGalleryImages,
    roomData,
    fees,
    threeD,
    threeSixties,
    twoD,
    video,
    view,
  } = floorPlanData;

  const twoDSrc = twoD?.modal;
  const threeDSrc = threeD?.modal;

  if ( ( fees?.length > 0 ) || description ) {
    navBtns.push( {
      section: 'info-scroll',
      text: 'Info',
    } );
  }

  if ( twoDSrc || threeDSrc ) {
    navBtns.push( {
      section: 'floorplan-scroll',
      text: 'Floor Plan',
    } );
  }

  if ( roomData?.length > 0 ) {
    navBtns.push( {
      section: 'dimensions-scroll',
      text: 'Dimensions',
    } );
  }

  if ( view?.length > 0 ) {
    navBtns.push( {
      section: 'view-scroll',
      text: 'View',
    } );
  }

  if ( photoGalleryImages?.length > 0 ) {
    navBtns.push( {
      section: 'slideshow-scroll',
      text: 'Photos',
    } );
  }

  if ( video ) {
    navBtns.push( {
      section: 'video-scroll',
      text: 'Video',
    } );
  }

  if ( threeSixties?.length > 0 ) {
    navBtns.push( {
      section: 'tour-scroll',
      text: 'Tour',
    } );
  }

  if ( furnitureConfiguratorUrl ) {
    navBtns.push( {
      section: 'configurator-scroll',
      text: 'Furniture Layout',
    } );
  }

  if ( finishCollection && Object.keys( finishCollection ).length !== 0 ) {
    navBtns.push( {
      section: 'finishes-scroll',
      text: 'Finishes',
    } );
  }

  return navBtns;
}

export function createBedBathSqFtTableData( data ) {
  const {
    bed, bath, studio, sqft, withDen,
  } = data;

  const tableInfo = [];

  if ( bed || bath || studio ) {
    const bedString = bed || '';
    const bedBathSeperator = bed && bath ? '/ ' : '';
    const denString = withDen === 'Yes' ? 'with Den ' : '';
    const bathString = bath || '';
    const bedBathString = studio ? 'Studio' : `
      ${bedString}
      ${bedBathSeperator}
      ${bathString}
      ${denString}
    `;
    const bedBathInfo = {
      label: 'Bedroom & Bathroom',
      data: bedBathString,
      type: 'bedBath',
    };
    tableInfo.push( bedBathInfo );
  }

  if ( sqft ) {
    // add comma to sqft
    const humanSqFt = humanizeNumber( sqft );
    const sqftInfo = {
      label: 'Square Footage',
      data: humanSqFt,
      type: 'sqft',
    };
    tableInfo.push( sqftInfo );
  }

  return tableInfo;
}

// add the appropriate words to the bed, bath, sqft values
export function bedBathSqftArray( studio, bed, bath, sqft, withDen = 'No',  ) {
  const items = [];

  if ( studio ) {
    items.push( 'Studio' );
  } else {
    if ( bed ) {
      const bedString = `${bed} Bed${withDen === 'Yes' ? ' w/ Den' : ''}`;
      items.push( bedString );
    }
    if ( bath ) {
      const bathString = `${bath} Bath`;
      items.push( bathString );
    }
  }

  if ( sqft ) {
    const humanSqft = humanizeNumber( sqft );
    const sqftString = `${humanSqft} sq. ft.`;
    items.push( sqftString );
  }

  return items;
}

export function assembleFloorPlanHeaderTextData( floorPlanData ) {
  const {
    title,
    levelOfCareName,
    floorPlanCategoryName,
    remainingInventory,
  } = floorPlanData;

  // Assemble header text.
  const subtitleArray = [];
  if ( levelOfCareName ) {
    subtitleArray.push( levelOfCareName );
  }
  if ( floorPlanCategoryName ) {
    subtitleArray.push( floorPlanCategoryName );
  }

  const headerText = {
    title,
    tags: [],
    subtitle: subtitleArray.join( ' ' ),
  };

  // Add inventory tag.
  if ( remainingInventory && remainingInventory <= 3 ) {
    const inventoryPhrase = remainingInventory > 0 ? `${remainingInventory} Left` : 'Sold Out';
    headerText.tags.push(
      {
        type: 'soldOut',
        text: inventoryPhrase,
      },
    );
  }

  return headerText;
}
